import { Routes } from '@angular/router'
import { ElderAccessDeniedComponent } from '@elderbyte/ngx-starter'
import { HasRoleGuard } from '@elderbyte/ngx-auth'
import { DashboardComponent } from './domain/dashboard/dashboard.component'
import { SettingsComponent } from './domain/settings/settings.component'
import { JobBrowserComponent } from './domain/jobs/job-browser/job-browser.component'
import { JobDetailComponent } from './domain/jobs/job-detail/job-detail.component'

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'app/jobs',
    pathMatch: 'full',
  },

  {
    path: 'app',
    children: [
      {
        path: '',
        redirectTo: 'jobs',
        pathMatch: 'full',
      },
      {
        path: 'accessdenied',
        component: ElderAccessDeniedComponent,
      },

      // Dashboard
      {
        path: 'dashboard',
        canActivate: [HasRoleGuard],
        component: DashboardComponent,
        data: {
          roles: ['USER'],
          title: 'dashboard.title',
        },
      },

      // Jobs
      {
        path: 'jobs',
        canActivate: [HasRoleGuard],
        component: JobBrowserComponent,
        data: {
          roles: ['USER'],
          title: 'jobs.title',
        },
      },

      {
        path: 'jobs/:id',
        component: JobDetailComponent,
        canActivate: [HasRoleGuard],
        data: {
          roles: ['USER'],
          title: 'jobs.title',
          jobId: ':id',
        },
      },

      // Settings
      {
        path: 'settings',
        canActivate: [HasRoleGuard],
        component: SettingsComponent,
        data: {
          roles: ['USER'],
          title: 'settings.title',
        },
      },
    ],
  },

  /// Outlet Side
  {
    path: '**',
    redirectTo: 'app',
    pathMatch: 'full',
  },
]
